import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/Layout';
import PageHead from '../components/Head/PageHead';
import PersonPage from '../components/PersonPage/PersonPage';
import { relativeToAbsUrl } from '../utils/urls';

export default ({ data, location, path }) => {
  const { name = '', image = { asset: {} } } = data.person || {};
  const meta = {
    title: `${name} | Ambassador`,
    seoDescription: `All resources published in the Ambassador website by ${name}`,
    ogImage: { asset: { _ref: image.asset._id } },
  };
  return (
    <React.Fragment>
      <PageHead
        meta={meta}
        schema={{ type: 'person', ...data.person }}
        // canonicalUrl={relativeToAbsUrl(path)}
      />
      <Layout location={location}>
        <PersonPage {...data} />
      </Layout>
    </React.Fragment>
  );
};

export const query = graphql`
  query($references: [String]!, $_id: String!) {
    person: sanityPerson(_id: { eq: $_id }) {
      name
      image {
        asset {
          _id
          fluid(maxWidth: 350) {
            ...GatsbySanityImageFluid_noBase64
          }
        }
      }
      role
    }
    resourcePages: allSanityResourcePage(filter: { _id: { in: $references } }) {
      nodes {
        id
        _updatedAt
        meta {
          title
          ogImage {
            asset {
              _id
            }
          }
          slug {
            current
          }
          topics {
            title
          }
          type {
            title
            svg
          }
        }
      }
    }
    webinars: allSanityWebinar(
      filter: { speakers: { elemMatch: { _id: { eq: $_id } } } }
    ) {
      nodes {
        id
        _updatedAt
        meta {
          title
          ogImage {
            asset {
              _id
            }
          }
          slug {
            current
          }
          topics {
            title
          }
          type {
            title
            svg
          }
        }
      }
    }
  }
`;
